module.exports = __webpack_public_path__ + "img/kelpie-2.4192b2fd.jpg";